module.exports = __webpack_public_path__ + "static/semantic-placeholder-basic-e220eaec17f6ff47e74caa252484fb87.gif";